export const messages = {
  labels: {
    clinicalFindingDate: {
      id: 'treatmentSummary.Groups.InitialClinicalFinding.ClinicalFindingDate',
      defaultMessage: 'Date: ',
    },
    diseaseSite: {
      id: 'treatmentSummary.Groups.InitialClinicalFinding.DiseaseSite',
      defaultMessage: 'Site: ',
    },
    clinicalFindings: {
      id: 'treatmentSummary.Groups.InitialClinicalFinding.ClinicalFindings',
      defaultMessage: 'Findings: ',
    },
    providerName: {
      id: 'treatmentSummary.Groups.InitialClinicalFinding.ProviderName',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.InitialClinicalFinding.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.InitialClinicalFinding.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.InitialClinicalFinding.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.InitialClinicalFinding.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
